import { useState } from 'react';

import { DEFAULT_PAGINATION } from '../../components/Table/constants/defaults';
import { Pagination } from '../../types';

/**
 * Pagination state hook
 *
 * @param initialPerPage - Initial items per page
 * @param initialPage - Initial page number
 * @returns Tuple containing pagination state and setter function
 */
export const usePaginationState = (
  initialPerPage: number = DEFAULT_PAGINATION.perPage,
  initialPage: number = DEFAULT_PAGINATION.page,
) => {
  const [pagination, setPagination] = useState<Pagination>({
    perPage: initialPerPage,
    page: initialPage,
  });

  return [pagination, setPagination] as const;
};
